export const UPDATE_PROJECT_META_DATA = "UPDATE_PROJECT_META_DATA";
export const UPDATE_PROJECT_META_DATA_LOADING =
  "UPDATE_PROJECT_META_DATA_LOADING";
